import { render, staticRenderFns } from "./QuotasCard.vue?vue&type=template&id=61a6b72c"
import script from "./QuotasCard.vue?vue&type=script&lang=js"
export * from "./QuotasCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports